
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import "./index.css";
  import { registerServiceWorker } from "./lib/pwa";
  import { initializePreloading } from "./lib/preload";
  import { initializeLiveRegions } from "./hooks/useLiveRegion";
  import { initErrorLogger } from "./lib/errorLogger";
  import { projectId } from "./utils/supabase/info";

  // Initialize error logger FIRST (must be before anything else)
  initErrorLogger();

  // Initialize preloading strategies
  initializePreloading({
    supabaseUrl: `https://${projectId}.supabase.co`,
  });

  // Initialize global live regions for accessibility
  initializeLiveRegions();

  // Register service worker for PWA
  // @ts-ignore - Vite env
  if (import.meta.env?.PROD) {
    registerServiceWorker().then((registration) => {
      if (registration) {
        console.log('[App] PWA ready');
      }
    });
  }

  // @ts-ignore - React types
  createRoot(document.getElementById("root")!).render(<App />);
  